import { Box, Typography, Paper, Container } from "@mui/material";
import React from "react";
import { motion } from "motion/react";

/** Pantalla principal, renderizara Menu lateral, header y footer util para manejos globales y permisos */
const HomePage = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <Box>
        <Paper
          elevation={2}
          sx={{
            p: 4,
            borderRadius: 2,
            backgroundColor: "background.paper",
          }}
        >
          <Typography variant="h4" component="h1" gutterBottom>
            Bienvenido al Sistema Integrado de Pedidos
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Esta es la página principal de tu aplicación. Aquí puedes agregar el
            contenido principal como dashboard, estadísticas, o cualquier
            funcionalidad que necesites.
          </Typography>
        </Paper>
      </Box>
    </motion.div>
  );
};

export default HomePage;
